import { AuthActions } from "@carm/_auth/spartacus/core/auth";

export interface AuthRefreshTokenExtendState {
  refreshTokenSuccess: boolean;
  refreshTokenError: any;
}

export const initialState: AuthRefreshTokenExtendState = {
  refreshTokenSuccess: false,
  refreshTokenError: null,
};

export function reducer(state: AuthRefreshTokenExtendState = initialState, action: AuthActions.UserTokenAction): AuthRefreshTokenExtendState {
  switch (action.type) {
    case AuthActions.REFRESH_USER_TOKEN_SUCCESS: {
      return {
        ...state,
        refreshTokenSuccess: true,
      };
    }
    case AuthActions.REFRESH_USER_TOKEN_FAIL: {
      return {
        ...state,
        refreshTokenSuccess: false,
        refreshTokenError: action.payload,
      };
    }
  }
  return state;
}





